"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useId = void 0;
const React = __importStar(require("react"));
// https://github.com/reactwg/react-18/discussions/111#discussioncomment-1517837
let counter = 1;
function usePolyfilledId() {
    const [value] = React.useState(() => {
        const value = counter;
        counter += 1;
        return `app-utils-id-${value.toString()}`;
    });
    return value;
}
// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useReactId = React['useId'.toString()];
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * simple polyfill for older versions
 */
exports.useId = useReactId ?? usePolyfilledId;
//# sourceMappingURL=use_id.js.map